import {
  greenMagebolt,
  nature_mend
} from "../../../abilities";
const NATURE_WAND = {
  slug: "nature-wand",
  name: "Nature Wand",
  description: "A wand humming with the energy of the forest",
  rarity: "uncommon",
  slot: "weapon",
  shopCategory: "magic",
  statChanges: [
    { stat: "mana", value: 30 },
    { stat: "greenColor", value: 7 }
  ],
  grantedActions: { greenMagebolt, nature_mend },
  sprite: {
    sheet: "weapons/magic_weapons/wand",
    frameIndex: 0
  },
  spriteTint: "green",
  tags: ["daily-rotation", "magic"]
};
export {
  NATURE_WAND
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL3dlYXBvbnMvd2FuZHMvbmF0dXJlLXdhbmQudHMiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIi8qKlxuICogTmF0dXJlIFdhbmQgLSBDb21tb24gbmF0dXJlIG1hZ2ljIHdlYXBvblxuICovXG5cbmltcG9ydCB7XG4gIGdyZWVuTWFnZWJvbHQsXG4gIG5hdHVyZV9tZW5kLFxufSBmcm9tICcuLi8uLi8uLi9hYmlsaXRpZXMnO1xuaW1wb3J0IHsgSXRlbURlZmluaXRpb24gfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBOQVRVUkVfV0FORDogSXRlbURlZmluaXRpb24gPSB7XG4gIHNsdWc6ICduYXR1cmUtd2FuZCcsXG4gIG5hbWU6ICdOYXR1cmUgV2FuZCcsXG4gIGRlc2NyaXB0aW9uOlxuICAgICdBIHdhbmQgaHVtbWluZyB3aXRoIHRoZSBlbmVyZ3kgb2YgdGhlIGZvcmVzdCcsXG4gIHJhcml0eTogJ3VuY29tbW9uJyxcbiAgc2xvdDogJ3dlYXBvbicsXG5cbiAgc2hvcENhdGVnb3J5OiAnbWFnaWMnLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHsgc3RhdDogJ21hbmEnLCB2YWx1ZTogMzAgfSxcbiAgICB7IHN0YXQ6ICdncmVlbkNvbG9yJywgdmFsdWU6IDcgfSxcbiAgXSxcbiAgZ3JhbnRlZEFjdGlvbnM6IHsgZ3JlZW5NYWdlYm9sdCwgbmF0dXJlX21lbmQgfSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3ZWFwb25zL21hZ2ljX3dlYXBvbnMvd2FuZCcsXG4gICAgZnJhbWVJbmRleDogMCxcbiAgfSxcbiAgc3ByaXRlVGludDogJ2dyZWVuJyxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICdtYWdpYyddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUlBO0FBQUEsRUFDRTtBQUFBLEVBQ0E7QUFBQSxPQUNLO0FBR0EsTUFBTSxjQUE4QjtBQUFBLEVBQ3pDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQ0U7QUFBQSxFQUNGLFFBQVE7QUFBQSxFQUNSLE1BQU07QUFBQSxFQUVOLGNBQWM7QUFBQSxFQUNkLGFBQWE7QUFBQSxJQUNYLEVBQUUsTUFBTSxRQUFRLE9BQU8sR0FBRztBQUFBLElBQzFCLEVBQUUsTUFBTSxjQUFjLE9BQU8sRUFBRTtBQUFBLEVBQ2pDO0FBQUEsRUFDQSxnQkFBZ0IsRUFBRSxlQUFlLFlBQVk7QUFBQSxFQUM3QyxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsWUFBWTtBQUFBLEVBQ1osTUFBTSxDQUFDLGtCQUFrQixPQUFPO0FBQ2xDOyIsCiAgIm5hbWVzIjogW10KfQo=
